import React, {
  useState, useEffect, useMemo, forwardRef,
} from 'react';

import { SearchIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import debounce from 'lodash/debounce';

import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';

import { useUserListFilters } from '../useUserListPageFilters';
import st from './popovers.module.sass';
import { useGetRoles } from '@vlabs/api/artemy/client';

function UserRoleFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const [searchInputValue, setSearchInputValue] = useState<string | undefined>(undefined);
  const { filters, updateFilters } = useUserListFilters();
  const { data } = useGetRoles({ page_size: 15, name: searchInputValue });

  const userRoleOptions = data?.roles?.map((r) => ({ label: r.name, value: r.role_id }));

  const debouncedSetRole = useMemo(() => debounce((value: string) => {
    setSearchInputValue(value);
  }, 1000), []);

  useEffect(() => {
    return () => {
      debouncedSetRole.cancel();
    };
  }, [debouncedSetRole]);

  return (
    <PopoverWithButton
      {...props}
      onClickReset={() => updateFilters({ role_id: undefined })}
      ref={ref}
    >
      <div className={st.Options}>
        <Control.Input
          icon={<SearchIcon />}
          onChange={(e) => debouncedSetRole(e.target.value)}
        />
        <div className={st.RadioWrapper}>
          {userRoleOptions?.map((option) => {
            return (
              <Control.Radio
                checked={filters.role_id === option.value}
                key={option.value}
                label={option.label}
                onChange={() => updateFilters({ role_id: option.value })}
              />
            );
          })}
        </div>
        <div className={st.Divider} />
      </div>
    </PopoverWithButton>
  );
}

const UserRoleFilterPopoverWithRef = forwardRef(UserRoleFilterPopover);
export { UserRoleFilterPopoverWithRef as UserRoleFilterPopover };
